import React, { FunctionComponent } from 'react';

import './styles/_main.scss';

import AssetNameInput from '@components/asset/modal/tabs/edit/side_bar/assetNameInput';

import AttachmentListContainer from './attachmentListContainer';

interface GenericFileSideBarProps {
  isTask?: boolean;
}

const GenericFileSideBar: FunctionComponent<GenericFileSideBarProps> = ({
  isTask
}) => (
  <div className="edit-tab-sidebar one-third bf-scroll-element">
    <AssetNameInput assetNameCopy={isTask ? bfTranslate('Task Name') : bfTranslate('Asset Name')} />
    <AttachmentListContainer isTask={isTask} />
  </div>
);

export default GenericFileSideBar;
